export default __webpack_public_path__ + "images/dhruv.bba0bf72492cf33e0015.png";